import React from 'react';
import styled from 'styled-components';
import * as color from '@constant/color';
import * as size from '@constant/size';
import TextBlock from '@component/common/block/text-block';
import { IClozeExplanationModalData } from '@datatype/iyagigo/type';
import Scroll from '@component/common/scroll';
import { v4 as uuid4 } from 'uuid';
import { useTypedSelector } from '@hook/common/useStore';
import { MODAL_SCROLL_HEIGHT, LARGE_MODAL_WIDTH } from '@constant/size';
import { normalizeExplanation } from '@util/string';

interface IProps {
  data: IClozeExplanationModalData['data'];
}

const Wrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  width: ${LARGE_MODAL_WIDTH};
`;

const TITLE_TEXT_DESIGN = {
  text: { size: 'medium', color: color.BLACK_2, bold: true },
  box: { margin: `0px 0px ${size.MARGIN_1} 0px` },
} as const;

const EXPLANATION_DESIGN = {
  text: { size: 'medium', color: color.BLACK_2, bold: false },
  box: { alignX: 'left', width: '100%' },
} as const;

const ExplanationContainer = styled.div`
  //white-space: pre-wrap;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  background-color: ${color.BROWN_4};
  padding: ${size.MARGIN_1};
  gap: ${size.MARGIN_1};
`;

const ClozeExplanationModal: React.FC<IProps> = ({ data }) => {
  const studyLanguage = useTypedSelector((state) => state.rootReducer?.studentReducer?.currentStudyLanguage) ?? null;

  const getLanguagePrefix = (language: string) => {
    switch (language) {
      case 'korean':
        return '[한국어]';
      case 'english':
        return '[영어]';
      case 'japanese':
        return '[일본어]';
      default:
        return '[한국어]';
    }
  };

  const languagePrefix = getLanguagePrefix(studyLanguage ?? null);
  const filteredData = data
    .filter((item) => item.startsWith(languagePrefix))
    .map((item) => item.replace(languagePrefix, '').trim());

  return (
    <Wrapper>
      <TextBlock text='문제풀이' design={TITLE_TEXT_DESIGN} />
      <Scroll direction='y' height={MODAL_SCROLL_HEIGHT}>
        <ExplanationContainer>
          {filteredData.map((item) => (
            <TextBlock key={uuid4()} text={`· ${normalizeExplanation(item)}`} design={EXPLANATION_DESIGN} />
          ))}
        </ExplanationContainer>
      </Scroll>
    </Wrapper>
  );
};

export default ClozeExplanationModal;
